import React from 'react'
import { motion } from 'framer-motion'
import './SmmCard.css'

export default function SmmCard(props) {
    return (
        <motion.li className={`smm-card container-vertical  ${[props.isActive ? 'active' : '']} `}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        >
            <div className='smm-title fs-medium fw-semibold text-align-center'>{props.title}</div>
            <div className='smm-content text-align-center'>{props.content}</div>
        </motion.li>
    )
}
